@if (loaded()) {
    <div class="chat-wrapper">
        @if (isStandalone()) {
            <app-custom-header [hideSubmenu]="true" [showFeedbackButton]="accessType() === 'private'" (feedbackClick)="showFeedback()" />
        }
        <app-vatutor-chat
            #chat
            [token]="accessToken()"
            [intro]="chatIntro()"
            [standalone]="isStandalone()"
            [courseId]="courseId()"
            [subTenantName]="subTenantName()"
            [userType]="accessType() === 'private' ? 'user' : 'default'"
            [useGenerateEndpoint]="useGenerateEndpoint()"
            [saveAs]="saveAs()"
            [chatClosed]="shouldStartClosed() ? true : !autoOpen()"
            [dialog]="dialogMode()"
        ></app-vatutor-chat>
    </div>
}
